(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-guarantee-notice"] && !Shopify.designMode) return;
  try {
    const setupLegalGuaranteeNotice = () => {
    const dialog = document.querySelector('[data-legal-guarantee-dialog]');
    if (!dialog || dialog.dataset.initialized === 'true') return;

    const openButtons = document.querySelectorAll('[data-legal-guarantee-open]');
    const closeButton = dialog.querySelector('[data-legal-guarantee-close]');
    let lastTrigger = null;

    const openDialog = (event) => {
      lastTrigger = event.currentTarget;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    openButtons.forEach((button) => button.addEventListener('click', openDialog));
    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => lastTrigger?.focus());
    dialog.dataset.initialized = 'true';
  };

  setupLegalGuaranteeNotice();
  document.addEventListener('shopify:section:load', setupLegalGuaranteeNotice);
  } catch(e) { console.error(e); }
})();

})();
